// removed by extract-text-webpack-plugin
module.exports = {"row":"umElGc6EV0OyqMSedm_UE","footerP":"_141Y-9BLuah4aCEbWlgBlm","logosContainer":"_2gsabTfjw_pIjunUoPYqxe","logoGtx":"_2-f7Xz2UuUnLd3vl_tU_D7","inline":"_3qR147S9wXfQsz-Fmfsort","fooBro":"_3wLCneMKlfOJdr6UAvOT3A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.css
// module id = 367
// module chunks = 0